import { useTranslation } from '../i18n';

import React, { useState, useEffect } from 'react';
import { Select, Spin, Tooltip } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import geoService from '../services/geoService';

const { Option } = Select;

const CidrSelector = ({ value, onChange }) => {
    const { t } = useTranslation();
    const [loading, setLoading] = useState(false);
    const [cidrs, setCidrs] = useState([]);

    useEffect(() => {
        const fetchCidrs = async () => {
            setLoading(true);
            try {
                const result = await geoService.getCidrStats();
                if (result.success) {
                    setCidrs(Object.entries(result.data).map(([id, stats]) => ({
                        id: parseInt(id),
                        name: stats.name || t('CIDR group {{id}}', { id: id }),
                        ipv4_count: stats.ipv4_count || 0,
                        ipv6_count: stats.ipv6_count || 0
                    })));
                }
            } catch (error) {
                console.error('Error loading CIDRs:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchCidrs();
    }, [t]);

    const handleChange = (selectedValue) => {
        if (onChange) {
            // 处理清除选择或空值的情况
            if (selectedValue === undefined || selectedValue === null || selectedValue === '') {
                onChange({
                    cidr_id: 0,
                    cidr_name: ''
                });
                return;
            }

            const cidrId = parseInt(selectedValue) || 0;
            // 查找CIDR名称
            const selectedCidr = cidrs.find(item => item.id === cidrId);
            const cidrName = selectedCidr ? selectedCidr.name : '';

            // 返回包含id和name的对象
            onChange({
                cidr_id: cidrId,
                cidr_name: cidrName
            });
        }
    };

    // 兼容传入整数或对象的情况
    const displayValue = (() => {
        if (!value) return '0';
        if (typeof value === 'object') {
            return value.cidr_id ? value.cidr_id.toString() : '0';
        }
        return value.toString();
    })();

    return (
        <Spin spinning={loading}>
            <Select
                placeholder={t('Select a CIDR group')}
                style={{ width: '100%' }}
                value={displayValue}
                onChange={handleChange}
                allowClear
            >
                <Option value="0">{t('None (matches any IP)')}</Option>
                {cidrs.map(cidr => (
                    <Option key={cidr.id} value={cidr.id.toString()}>
                        {cidr.name}
                        {' '}
                        <Tooltip title={`IPv4: ${cidr.ipv4_count}, IPv6: ${cidr.ipv6_count}`}>
                            <InfoCircleOutlined />
                        </Tooltip>
                        {' '}
                        {t('({{count}} rules)', { count: cidr.ipv4_count + cidr.ipv6_count })}
                    </Option>
                ))}
            </Select>
        </Spin>
    );
};

export default CidrSelector;
